module.exports = __webpack_public_path__ + "img/hooch_stocks.a570d5bf.jpg";